module.exports = __webpack_public_path__ + "static/media/long_shank_insulator_pin.9aa9a033.webp";